<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M 10.546,2.438c0.723,0.803,1.961,0.868,2.764,0.144c0.051-0.046,0.099-0.094,0.144-0.144L14.4,1.4 c0.725-0.803,1.964-0.866,2.767-0.14c0.437,0.395,0.673,0.965,0.643,1.553l-0.071,1.4c-0.054,1.08,0.777,2,1.857,2.054 c0.065,0.003,0.129,0.003,0.194,0l1.4-0.071c1.081-0.053,2,0.78,2.053,1.86c0.029,0.587-0.207,1.156-0.643,1.55l-1.042,0.94 c-0.803,0.726-0.866,1.965-0.141,2.768c0.044,0.049,0.091,0.096,0.141,0.141l1.042,0.94c0.803,0.725,0.866,1.964,0.14,2.767 c-0.395,0.437-0.965,0.673-1.553,0.643l-1.4-0.071c-1.08-0.056-2,0.775-2.056,1.855c-0.003,0.067-0.003,0.134,0,0.201l0.071,1.4 c0.048,1.081-0.789,1.996-1.87,2.044c-0.579,0.026-1.14-0.206-1.532-0.634l-0.941-1.041c-0.725-0.803-1.964-0.866-2.767-0.141 c-0.049,0.045-0.097,0.092-0.141,0.141L9.606,22.6c-0.728,0.8-1.967,0.859-2.767,0.131c-0.431-0.392-0.665-0.956-0.639-1.539 l0.072-1.4c0.056-1.08-0.775-2-1.855-2.056c-0.067-0.003-0.134-0.003-0.201,0l-1.4,0.071c-1.08,0.056-2.001-0.773-2.057-1.853 C0.728,15.366,0.963,14.795,1.4,14.4l1.041-0.94c0.803-0.726,0.866-1.965,0.141-2.768c-0.044-0.049-0.091-0.096-0.141-0.141 L1.4,9.606C0.599,8.879,0.539,7.641,1.265,6.84C1.658,6.407,2.225,6.172,2.809,6.2l1.4,0.071c1.08,0.057,2.001-0.773,2.058-1.852 c0.004-0.069,0.004-0.138,0-0.208L6.2,2.81C6.149,1.729,6.984,0.812,8.065,0.761C8.648,0.734,9.213,0.968,9.606,1.4L10.546,2.438z "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 12,7.501c2.485,0,4.5,2.015,4.5,4.5s-2.015,4.5-4.5,4.5s-4.5-2.015-4.5-4.5S9.515,7.501,12,7.501z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconSettings",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>